/**
 * Swiper — 使用モジュールのみ登録
 */
import Swiper, { Navigation, Autoplay, EffectFade, Thumbs, Parallax, Pagination } from "swiper";

Swiper.use([Navigation, Autoplay, EffectFade, Thumbs, Parallax, Pagination]);

export default Swiper;
